<template>
    <AddRoleDialog
            :dialogTitle="dialogTitle"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'600px'"
    >
        <el-form ref="form" :model="query" :rules="rules" label-width="120px">
            <el-form-item label="角色名称:" prop="roleName">
                <el-input v-model="query.roleName"></el-input>
            </el-form-item>
            <el-form-item label="角色描述:" prop="remark">
                <el-input v-model="query.remark"></el-input>
            </el-form-item>
        </el-form>
    </AddRoleDialog>
</template>

<script>
    import AddRoleDialog from '../../../../components/common/epecDialog'
    import Api from '../../api/authority/index'
    export default {
        name: "addRoleDialog",
        components: {
            AddRoleDialog
        },
        props: {
            dialogTitle:{
                type:String,
                required:true
            },
            visible:{
                type:Boolean,
                required: true
            },
            roleData:{
                type:Object,
                required: true
            }
        },
        data() {
            return {
                query:{
                    roleName: '',
                    remark: ''
                },
                rules:{
                    roleName:[{
                        required: true,message:'请输入角色名称',blur:'trigger'
                    }],
                    remark:[{
                        required: true,message:'请输入角色描述',blur:'trigger'
                    }]
                }
            }
        },
        computed: {},
        created() {
        },
        methods: {
            updateVisible(){

            },
            resetPopupData(){
                this.query.roleName = ''
                this.query.remark = ''
                this.$emit('close')
            },
            submitPopupData(){
                this.addRole()
            },
            addRole(){
                if(this.dialogTitle == '新增角色'){
                    let params = {
                        roleName: this.query.roleName,
                        remark: this.query.remark,
                        companyId: 8
                    }
                    this.$refs.form.validate((valid) => {
                        if(valid){
                            Api.addRole(params)
                                .then((res) => {
                                    if(res.code == '200'){
                                        this.$message({
                                            type:'success',
                                            message:'添加角色成功'
                                        })
                                        this.$emit('close')
                                    }
                                })
                        }else {
                            this.$message({
                                type:'error',
                                message:'添加角色失败'
                            })
                        }
                    })
                }else {
                    let params = {
                        roleName: this.query.roleName,
                        remark: this.query.remark,
                        roleId: this.roleData.roleId,
                        companyId: 8
                    }
                    this.$refs.form.validate((valid) => {
                        if(valid){
                            Api.updateRole(params)
                                .then((res) => {
                                    if(res.code == '200'){
                                        this.$message({
                                            type:'success',
                                            message:'修改成功'
                                        })
                                        this.$emit('close')
                                    }
                                })
                        }else {
                            this.$message({
                                type:'error',
                                message:'添加角色失败'
                            })
                        }
                    })
                }


            }
        },
        watch:{
           roleData:{
               handler: function (val) {
                   this.query.roleName = val.roleName
                   this.query.remark = val.remark
               },
               deep: true,
               immediate: true
           }
        }

    }
</script>

<style scoped>

</style>
